export default "/assets/Icon/Sound.svg"